import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  FiPhoneCall,
  FiMail,
  FiSmartphone,
  FiHelpCircle,
  FiArrowRight,
  FiCreditCard,
  FiMessageSquare,
  FiHome,
  FiAward,
  FiMapPin,
} from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { pageStatusChange } from "../../redux/property/PropertySlice";

const DashBoard = () => {
  const { loginData } = useSelector((store) => store.Athentication);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const credits = loginData?.creadits ?? 0;

  return (
    <div className="mgh-overview-container">
      {/* 1. Modern Welcome & Hero Banner */}
      <section className="mgh-overview-hero">
        <div className="mgh-overview-hero-badge">
          <FiAward size={14} />
          <span>Seller & Dealer Overview</span>
        </div>
        <h1 className="mgh-overview-hero-title">
          Maximize your business with <span>EwRealty</span>
        </h1>
        <p className="mgh-overview-hero-sub">
          Utilize our offerings to connect with genuine buyers, manage listings, and close property deals faster.
        </p>
      </section>

      {/* 2. Key Metrics & Quick Actions (3 Cards) */}
      <section className="mgh-overview-stats-grid">
        {/* Card 1: Credit Balance */}
        <div className="mgh-overview-stat-card">
          <div className="mgh-stat-card-header">
            <div className="mgh-stat-icon-wrap orange">
              <FiCreditCard size={20} />
            </div>
            <span className="mgh-stat-badge">Available Balance</span>
          </div>
          <div className="mgh-stat-card-body">
            <span className="mgh-stat-label">Your Credit Balance</span>
            <h3 className="mgh-stat-val">
              {credits} <span className="mgh-stat-unit">Credits</span>
            </h3>
            <p className="mgh-stat-hint">1 Credit = ₹1 • Instant Lead Unlocks</p>
          </div>
          <button
            type="button"
            className="mgh-stat-btn primary"
            onClick={() => dispatch(pageStatusChange(9))}
          >
            <span>Recharge & Plans</span>
            <FiArrowRight size={14} />
          </button>
        </div>

        {/* Card 2: Inquiries & Leads */}
        <div className="mgh-overview-stat-card">
          <div className="mgh-stat-card-header">
            <div className="mgh-stat-icon-wrap blue">
              <FiMessageSquare size={20} />
            </div>
            <span className="mgh-stat-badge blue">Instant Alerts</span>
          </div>
          <div className="mgh-stat-card-body">
            <span className="mgh-stat-label">Buyer Inquiries</span>
            <h3 className="mgh-stat-val">
              Leads on the Go
            </h3>
            <p className="mgh-stat-hint">View contact views & direct customer inquiries</p>
          </div>
          <button
            type="button"
            className="mgh-stat-btn"
            onClick={() => dispatch(pageStatusChange(21))}
          >
            <span>View All Leads</span>
            <FiArrowRight size={14} />
          </button>
        </div>

        {/* Card 3: Manage Properties */}
        <div className="mgh-overview-stat-card">
          <div className="mgh-stat-card-header">
            <div className="mgh-stat-icon-wrap green">
              <FiHome size={20} />
            </div>
            <span className="mgh-stat-badge green">100% Free Posting</span>
          </div>
          <div className="mgh-stat-card-body">
            <span className="mgh-stat-label">Your Properties</span>
            <h3 className="mgh-stat-val">
              Manage Listings
            </h3>
            <p className="mgh-stat-hint">Edit, boost, or add new properties anytime</p>
          </div>
          <button
            type="button"
            className="mgh-stat-btn"
            onClick={() => dispatch(pageStatusChange(4))}
          >
            <span>View Listings</span>
            <FiArrowRight size={14} />
          </button>
        </div>
      </section>

      {/* 3. Feature Highlights (2 Cards) */}
      <section className="mgh-overview-actions-grid">
        {/* Card A: Mobile App */}
        <div className="mgh-overview-feature-card">
          <div className="mgh-feature-top">
            <div className="mgh-feature-icon-badge">
              <FiSmartphone size={22} />
            </div>
            <div>
              <span className="mgh-feature-tag">MOBILE COMPANION</span>
              <h4 className="mgh-feature-title">Responses On The Go</h4>
            </div>
          </div>
          <p className="mgh-feature-desc">
            Check buyer inquiries anytime, anywhere! Get real-time WhatsApp and SMS notifications with the EwRealty app.
          </p>
          <div className="mgh-feature-footer">
            <button
              type="button"
              className="mgh-feature-btn"
              onClick={() => {
                window.open("https://ewrealty.com", "_blank");
              }}
            >
              <FiSmartphone size={16} />
              <span>Get Mobile App</span>
            </button>
          </div>
        </div>

        {/* Card B: FAQs & Knowledge */}
        <div className="mgh-overview-feature-card">
          <div className="mgh-feature-top">
            <div className="mgh-feature-icon-badge blue">
              <FiHelpCircle size={22} />
            </div>
            <div>
              <span className="mgh-feature-tag blue">HELP & GUIDES</span>
              <h4 className="mgh-feature-title">Need Help With Any Feature?</h4>
            </div>
          </div>
          <p className="mgh-feature-desc">
            Having trouble using features or listing your property? Explore our FAQ center for step-by-step guidance.
          </p>
          <div className="mgh-feature-footer">
            <button
              type="button"
              className="mgh-feature-btn secondary"
              onClick={() => navigate("/contactus")}
            >
              <FiHelpCircle size={16} />
              <span>Browse FAQ Section</span>
            </button>
          </div>
        </div>
      </section>

      {/* 4. Support & Helpdesk Card */}
      <section className="mgh-overview-support-card">
        <div className="mgh-support-card-head">
          <div className="mgh-support-head-left">
            <span className="mgh-support-badge">HELP & QUERIES</span>
            <h3 className="mgh-support-title">Dedicated Support For Owners & Dealers</h3>
            <p className="mgh-support-sub">
              Have questions regarding leads, packages, or listings? Our support team is here to assist you.
            </p>
          </div>
        </div>

        <div className="mgh-support-grid">
          <a href="tel:+919063483711" className="mgh-support-tile">
            <div className="mgh-support-tile-icon phone">
              <FiPhoneCall size={18} />
            </div>
            <div className="mgh-support-tile-content">
              <span className="mgh-support-tile-label">Call Helpline</span>
              <span className="mgh-support-tile-val">+91 90634 83711</span>
              <span className="mgh-support-tile-note">9:00 AM – 8:00 PM IST</span>
            </div>
          </a>

          <a
            href="https://wa.me/919063483711"
            target="_blank"
            rel="noopener noreferrer"
            className="mgh-support-tile"
          >
            <div className="mgh-support-tile-icon whatsapp">
              <FaWhatsapp size={20} />
            </div>
            <div className="mgh-support-tile-content">
              <span className="mgh-support-tile-label">WhatsApp Support</span>
              <span className="mgh-support-tile-val">+91 90634 83711</span>
              <span className="mgh-support-tile-note">Instant Chat Support</span>
            </div>
          </a>

          <a href="mailto:services@ewrealty.com" className="mgh-support-tile">
            <div className="mgh-support-tile-icon mail">
              <FiMail size={18} />
            </div>
            <div className="mgh-support-tile-content">
              <span className="mgh-support-tile-label">Email Support</span>
              <span className="mgh-support-tile-val">services@ewrealty.com</span>
              <span className="mgh-support-tile-note">Sales & Service Inquiries</span>
            </div>
          </a>

          <div
            className="mgh-support-tile"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/contactus")}
          >
            <div className="mgh-support-tile-icon location">
              <FiMapPin size={18} />
            </div>
            <div className="mgh-support-tile-content">
              <span className="mgh-support-tile-label">Office & Locations</span>
              <span className="mgh-support-tile-val">Hyderabad, Telangana</span>
              <span className="mgh-support-tile-note">View Branch Address</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DashBoard;
